import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

import Container from 'app/components/common/Container';

import PaginationComponent from '../common/PaginationComponent';

export default function FindYourDreamJobIndia() {
  const [positions, setPositions] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterJobs, setFilterJobs] = useState([]);
  const [paginationOptions, setPaginationOptions] = useState({
    totalResults: 0,
    page: 1,
    limit: 10,
  });
  const { page, limit } = paginationOptions;
  const [title, setTitle] = useState('');
  const [work, setWork] = useState('');
  const [city, setCity] = useState('');
  const [sortDate, setSortDate] = useState('NEWEST');
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    async function fetchPublishedPositions() {
      try {
        const tokenResponse = await fetch('/api/getToken', { method: 'POST' });
        const tokenData = await tokenResponse.json();

        if (!tokenResponse.ok) {
          throw new Error(tokenData.error || 'Failed to fetch token.');
        }

        const { access_token } = tokenData;

        if (!access_token) {
          throw new Error('Access token is missing.');
        }

        const positionsResponse = await fetch('/api/getPublishedPositions', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });

        const positionsData = await positionsResponse.json();

        if (positionsResponse.ok) {
          setPositions(positionsData?.response?.positions || []);
          setFilterJobs(positionsData?.response?.positions || []); // Initialize filterJobs
        } else {
          throw new Error(
            positionsData.error || 'An error occurred while fetching positions.'
          );
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchPublishedPositions();
  }, []);

  //   useEffect(() => {
  //     const dataToDisplay = filterJobs.length > 0 ? filterJobs : positions;
  //     const temp = dataToDisplay.slice(limit * (page - 1), limit * page);
  //     setPaginationOptions(prev => ({
  //       ...prev,
  //       totalResults: dataToDisplay.length,
  //     }));
  //     setJobs(temp);
  //   }, [positions, filterJobs, limit, page]);
  useEffect(() => {
    if (filterJobs && filterJobs?.length > 0) {
      const temp = filterJobs.slice(limit * (page - 1), limit * page);
      setPaginationOptions(prev => {
        return { ...prev, totalResults: filterJobs?.length };
      });
      setJobs(temp);
    } else {
      // Logic for default job display
      const SortByDate = (data, type) => {
        if (type === 'OLDEST') {
          data?.sort(
            (a, b) =>
              new Date(a?.positionPublishDate) -
              new Date(b?.positionPublishDate)
          );
          return data;
        } else {
          data?.sort(
            (a, b) =>
              new Date(b?.positionPublishDate) -
              new Date(a?.positionPublishDate)
          );
          return data;
        }
      };
      let data = SortByDate(positions, sortDate);
      const temp = data?.slice(limit * (page - 1), limit * page);
      setPaginationOptions(prev => {
        return { ...prev, totalResults: positions?.length };
      });
      setJobs(temp);
    }
  }, [positions, filterJobs, sortDate, limit, page]);

  if (loading) {
    return <p className="mt-[55px]">Loading positions...</p>;
  }

  if (error) {
    return <p className="mt-[55px]">Error: {error}</p>;
  }

  return (
    <Container className="pb-[55px]">
      {/* <JobFilter
        section={positions}
        setFilterJobs={setFilterJobs}
        setPaginationOptions={setPaginationOptions}
        sortDate={sortDate}
        setSortDate={setSortDate}
        title={title}
        setTitle={setTitle}
        work={work}
        setWork={setWork}
        city={city}
        setCity={setCity}
      /> */}
      <div className="mb-8">
        <h2 className="font-bold text-black text-4xl text-center">
          {filterJobs?.length}&nbsp;Jobs availables
        </h2>
      </div>
      <div>
        {jobs?.map(position => (
          <Link
            key={position?.code}
            href={`/resources/career/${encodeURIComponent(position.code)}`}
            className="block border border-[#B5B5B5] bg-[#ffffff] rounded-[10px] py-8 px-6 mb-8 cursor-pointer"
          >
            <div className="grid grid-cols-12 gap-0">
              <div className="lg:col-span-8 col-span-12 lg:mb-0 mb-4">
                {/* <h6 className="text-[24px] font-[600] text-[#1D1D1D] mb-3">
                  {position?.code}
                </h6> */}
                <h6 className="text-[24px] font-[600] text-[#1D1D1D] mb-3">
                  {position?.title}
                </h6>

                <p className="inline-block text-[#0C2139] text-[16px]  font-[600] border-l-[1px]  px-3 leading-[21px]">
                  Required Experience:
                  <span className=" text-[16px] font-[400] text-[#353535]">
                    {position?.minExperience}
                  </span>
                </p>
                <ul className="mt-3">
                  {position?.location?.map(location => (
                    <li
                      key={location?.id}
                      className="inline-block text-[#0C2139] text-[16px]  font-[600] px-2 leading-[21px]"
                    >
                      <span>{location}</span>
                    </li>
                  ))}
                  <li className="inline-block text-[#0C2139] text-[16px]  font-[600] border-l-[1px] border-l-[#0C2139] px-3 leading-[21px]">
                    Date of Posting :&nbsp;
                    {DateTime.fromJSDate(
                      position?.positionPublishDate &&
                        new Date(position?.positionPublishDate)
                    ).toFormat('MM-dd-yyyy')}
                  </li>
                </ul>
              </div>
              <div className="lg:col-span-4 col-span-12 lg:text-right text-left">
                <button class="border border-[#B5B5B5]  text-[12px] font-[600] text-[#1D1D1D] inline-flex items-center justify-center px-4 py-2 mr-2 mb-2">
                  Forward to a Friend
                  <Image
                    src="/img/Icon.svg"
                    alt="icon"
                    class="ml-2"
                    width={20}
                    height={20}
                  />
                </button>
                <button class="bg-[#0050D5]  text-[12px] font-[600] text-[#ffffff] rounded-[4px] px-4 py-2">
                  APPLY NOW
                </button>
              </div>
            </div>
          </Link>
        ))}

        {jobs && jobs.length > 0 && (
          <PaginationComponent
            paginationOptions={paginationOptions}
            onPagination={setPaginationOptions}
          />
        )}
      </div>
    </Container>
  );
}
